<template lang="html">
  <d-card class="card-small blog-comments">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">Chamado</h6>
    </d-card-header>

    <d-card-body class="p-0">
      <div v-for="(comment, index) in comments" :key="index" class="blog-comments__item d-flex p-3">

        <!-- Avatar -->
        <div class="blog-comments mr-3">
          <img :src="comment.user.image.url" :alt="comment.user.name" class="user-avatar rounded-circle mr-2" v-if="comment.user.image.url">
          <img class="user-avatar rounded-circle mr-2" src="@/assets/images/avatars/enhanced-buzz.jpeg" :alt="comment.user.name" v-else>
        </div>

        <!-- Content -->
        <div class="blog-comments__content ql-snow">

          <!-- Content - Title -->
          <div class="blog-comments__meta text-muted">
            <span class="text-secondary">{{ comment.user.name }}</span>
            <span class="text-muted"> – {{ comment.created_at }}</span>
            <span class="text-muted ml-2" v-if="comment.edited"> <small>Editado</small></span>
            <d-button size="sm" class="btn-outline-info ml-2 py-1" v-if="userId === comment.user.id" @click="editComment(comment)">Editar</d-button>
          </div>

          <!-- Content - Body -->
          <div class="m-0 my-1 mb-2">
            <div class="ql-editor p-0" v-html="comment.comment"></div>
          </div>

          <!-- Content - Actions -->
          <div class="blog-comments__actions mt-4" v-if="comment.files && comment.files.length > 0">
            <span class="text-secondary">Arquivos anexos</span>
            <ul class="files">
              <li v-for="(file, index) in comment.files" :key="index" class="files__file">
                <i class="fas fa-times-circle" @click="removeFile(file)"></i>
                <d-link :href="file.file.url" class="files__file-icon" target="_blank">
                  <i :class="'far fa-' + getIcon(file.file.type)"></i>
                  <span class="d-block text-center">{{ file.file.original_name || file.file.file_name }}</span>
                  <span class="d-block text-center">Download</span>
                </d-link>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </d-card-body>
  </d-card>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';

import { mapActions } from 'vuex';
import Events from '_utils/events';
import { getFileIcon } from '_utils/';
import { MODEL_COMMENT, _LOAD_COMMENT_, _OPEN_CONFIRMATION_ } from './TicketModel';

export default {
  name: 'chat-chamado',
  props: {
    comments: {
      type: Array,
      default: () => [{ ...MODEL_COMMENT }],
    },
  },
  computed: {
    userId() {
      const { user } = this.$store.state.user;
      return user.id;
    },
  },
  data() {
    return {
      file: null,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    getIcon(type) {
      return getFileIcon(type);
    },
    editComment(comment) {
      Events.$emit(_LOAD_COMMENT_, comment);
    },
    removeFile(file) {
      this.file = file;
      const params = {
        object: file,
        type: 'file',
        message: 'Arquivo deletado com sucesso',
      };
      Events.$emit(_OPEN_CONFIRMATION_, params);
    },
  },
};
</script>

<style lang="scss" scoped>
// User avatar
.user-avatar {
  max-width: 3.125rem;
  height: 3.125rem;
}

.files {
  list-style: none;
  padding-left: 0;
  margin: 10px 0 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  &__file {
    width: 90px;
    text-align: center;
    position: relative;
    .fa-times-circle {
      display: none;
    }
    &:hover {
      .fa-times-circle {
        font-size: 0.9rem;
        display: block;
        position: absolute;
        right: 0px;
        top: 0px;
        cursor: pointer;
      }
    }
    &-icon {
      i {
        font-size: 2rem;
      }
    }
  }
}
</style>
